export default __webpack_public_path__ + "img/9beb24232f099e3dd8cc1383801d6054.svg";